module.exports = __webpack_public_path__ + "static/img/pic3.427f3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic3.png
// module id = KZxS
// module chunks = 0